import React from 'react';

import { AvailableCategoryLabel } from '@utils';
import { StarMark } from 'components/common/StarMark/StarMark';

export const AgileEngineBenchStar: React.FC = () => (
  <StarMark label={AvailableCategoryLabel.agileengineer} color="text.purple" />
);
